module.exports = __webpack_public_path__ + "static/img/404.1c94039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/404.png
// module id = 498
// module chunks = 7